{
  "onboarding": {
    "skip": "SKIP",
    "next": "NEXT →",
    "start": "❤️ START EARNING",
    "welcome": {
      "title": "Welcome to\nAgápe Fund",
      "subtitle": "Promote the platform, earn Agápe Hearts, and support your favorite masters with real donations."
    },
    "earn": {
      "title": "How to Earn\nHearts",
      "subtitle": "Spread the word — every share, invite, and comment earns hearts:",
      "share": "Share any content",
      "invite": "Invite a friend",
      "subscribe": "Friend subscribes",
      "comment": "Comment on a post",
      "review": "Leave a review"
    },
    "convert": {
      "title": "Convert to\nDonations",
      "subtitle": "Your hearts become real money for masters.",
      "hearts100": "100 hearts",
      "source": "Fund source",
      "sourceVal": "10% of subs",
      "minDonation": "Min donation",
      "maxMonth": "Max per month"
    },
    "circle": {
      "title": "Create Your\nCircle",
      "subtitle": "To create your own community circle, you need:",
      "subscription": "Active subscription",
      "subscriptionVal": "Required",
      "hearts": "Minimum hearts",
      "approvals": "Friend approvals",
      "approvalsVal": "10 friends"
    }
  }
}
